import {
  DeleteOutlined,
  SearchOutlined,
} from '@ant-design/icons';
import {
  Breadcrumb,
  Button,
  Col,
  Form,
  Input,
  Pagination,
  Popconfirm,
  Row,
  Space,
  Table,
  Tabs,
  Tooltip,
  message,
} from 'antd';
import 'jspdf-autotable';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { ReactComponent as Back } from '../../Images/Back.svg';
import { ReactComponent as FilterIcon } from '../../Images/FilterIcon.svg';
import TabPane from 'antd/es/tabs/TabPane';
import { editstockverify, fetchstockUnverifyList, fetchstockverifyList } from '../../slices/stock-verify';

function AddNewReport() {
  const dispatch = useDispatch();
  const { data = [], totalRecord, status } = useSelector(state => state.stockverify);
  const { UnVerifydata = [], UnVerifydatatotalRecord } = useSelector(state => state.stockverify);
  const [orderBy, setOrderBy] = useState('');
  const [page, setPage] = useState(1);
  const [pageVerification, setPageVerification] = useState(1);
  const [form] = Form.useForm();
  const [pagesize, setPageSize] = useState(20);
  const [pageSizeVerification, setPageSizeVerification] = useState(20);
  const [activeTab, setActiveTab] = useState('1');
  const [searchverifyList, setSearchVerifyList] = useState(localStorage.getItem('addBundleVerification') || '');
  const [orderByverifyList, setorderByverifyList] = useState();
  const [search, setSearch] = useState(localStorage.getItem('addBundleUnVerification') || '');
  const [inputValue, setInputValue] = useState(localStorage.getItem('addBundleUnVerification') || '');
  const [inputVerificationInputValue, setVerificationInputValue] = useState(localStorage.getItem('addBundleUnVerification') || '');
  const dataSource = data.map((item, index) => ({
    ...item,
    key: item.id || index,
    SrNo: (page - 1) + index + 1, // Calculate Sr. No. based on page and limit
  }));
  const dataSourceTwo = UnVerifydata.map((item, index) => ({
    ...item,
    key: item.id || index,
    SrNo: (page - 1) + index + 1, // Calculate Sr. No. based on page and limit
  }));
  useEffect(() => {
    if (activeTab === undefined) {
      dispatch(setActiveTab('1')); // Assuming setActiveTab is an action to set activeTab in the Redux store
    }
  }, [activeTab, dispatch]);// Track

  useEffect(() => {

    dispatch(
      fetchstockUnverifyList({
        page,
        pagesize,
        ...(search && { search: search }),
        ...(orderBy && { ordering: orderBy }),
      }),
    );
  }, [page, pagesize, search, orderBy,]);

  useEffect(() => {
    dispatch(
      fetchstockverifyList({
        page: pageVerification,
        pagesize: pageSizeVerification,
        ...(searchverifyList && { search: searchverifyList }),
        ...(orderByverifyList && { ordering: orderByverifyList }),
      }),
    );

  }, [searchverifyList, orderByverifyList, pageSizeVerification, pageVerification]);

  const columns = [
    {
      title: 'Bunlde No.',
      dataIndex: 'bundle_no',
      key: 'bundle_no',

      width: '8%',
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      render: (status) => (status ? 'Verified' : 'Unverified'),
    },
    {
      title: 'Profile No',
      dataIndex: 'die_profile',
      key: 'die_profile',

    },
    {
      title: 'Length',
      dataIndex: 'length',
      key: 'length',

    },

    {
      title: 'Pieces',
      dataIndex: 'pieces',
      key: 'pieces',

    },
    {
      title: 'Weight',
      dataIndex: 'weight',
      key: 'weight',
      render: weight => {
        return (
          <span>
            {weight !== null && weight !== undefined
              ? weight.toFixed(3)
              : 'N/A'}
          </span>
        );
      },
    },
    {
      title: 'Avg. Weight',
      dataIndex: 'avg_weight',
      key: 'avg_weight',
      render: avg_weight => {
        return (
          <span>
            {avg_weight !== null && avg_weight !== undefined
              ? avg_weight.toFixed(3)
              : 'N/A'}
          </span>
        );
      },
    },
    {
      title: 'Alloy',
      dataIndex: 'alloy',
      key: 'alloy',
    },
    {
      title: 'Customer Name',
      dataIndex: 'party',
      key: 'party',
    },
    {
      title: 'Action',
      dataIndex: 'action',
      key: 'action',
      render: (_, record) => (
        <Space size="middle">
          <Link>
            <Tooltip title="Delete">
              <Popconfirm
                title="Are you sure you want to Delete this record?"
                onCancel={() => message.info('Action cancelled')}
                okText="Yes"
                cancelText="No"
              >
                <DeleteOutlined style={{ cursor: 'pointer', fontSize: '18px' }} />
              </Popconfirm>
            </Tooltip>
          </Link>
        </Space>
      ),
    },
  ];

  const columnsTwo = [
    {
      title: 'Bunlde No.',
      dataIndex: 'bundle_no', // Use a unique key for the serial number
      key: 'bundle_no',

      width: '8%',
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      render: (status) => (status ? 'Verified' : 'Unverified'),
    },
    {
      title: 'Profile No',
      dataIndex: 'die_profile',
      key: 'die_profile',

    },
    {
      title: 'Length',
      dataIndex: 'length',
      key: 'length',
    },
    {
      title: 'Pieces',
      dataIndex: 'pieces',
      key: 'pieces',

    },
    {
      title: 'Weight',
      dataIndex: 'weight',
      key: 'weight',
    },
    {
      title: 'Avg. Weight',
      dataIndex: 'avg_weight',
      key: 'avg_weight',
      render: avg_weight => {
        return (
          <span>
            {avg_weight !== null && avg_weight !== undefined
              ? avg_weight.toFixed(3)
              : 'N/A'}
          </span>
        );
      },
    },
    {
      title: 'Alloy',
      dataIndex: 'alloy',
      key: 'alloy',
    },
    {
      title: 'Customer Name',
      dataIndex: 'party',
      key: 'party',
    },
    {
      title: 'Action',
      dataIndex: 'action',
      key: 'action',
      render: (_, record) => (
        <Space size="middle">
          <Link>
            <Tooltip title="Delete">
              <Popconfirm
                title="Are you sure you want to Delete this record?"
                onCancel={() => message.info('Action cancelled')}
                okText="Yes"
                cancelText="No"
              >
                <DeleteOutlined style={{ cursor: 'pointer', fontSize: '18px' }} />
              </Popconfirm>
            </Tooltip>
          </Link>
        </Space>
      ),
    },
  ];

  const handleTabChange = key => {
    setActiveTab(key);
  };

  const handleTableChangeItemWiseSummary = async (pagination, filters, sorter) => {
    if (pagination?.pageSize) setPageSizeVerification(pagination.pageSize);
    if (pagination?.current) setPageVerification(pagination.current);
  };

  const handlePageSizeChange = (current, size) => {
    setPageVerification(1); // Reset to first page if needed
    setPageSizeVerification(size); // You must have a setter or state update
  };

  const handlePageChange = newPage => {
    setPageVerification(newPage);
    setOrderBy('');
  };


  const handleUnVerifydataPageSizeChange = (current, size) => {
    setPage(1); // Reset to first page if needed
    setPageSize(size); // You must have a setter or state update
  };

  const handleUnVerifydataPageChange = newPage => {
    setPage(newPage);
    setOrderBy('');
  };

  const handleTableChangeUnVerifydata = async (pagination, filters, sorter) => {
    if (pagination?.pageSize) setPageSize(pagination.pageSize);
    if (pagination?.current) setPage(pagination.current);
  };

  const handleSearch = (e) => {
    const value = e.target.value;
    setInputValue(value);
    setSearch(value);
    localStorage.setItem('addBundleUnVerification', value);
  };

  const handleSearchVerifyList = (e) => {
    const value = e.target.value;
    setVerificationInputValue(value);
    setSearchVerifyList(value);
    localStorage.setItem('addBundleVerification', value);
  };


  const resetFilter = () => {
    setSearch('');
    setInputValue('');
    setOrderBy(null);
    localStorage.removeItem('addBundleUnVerification');
    dispatch(fetchstockUnverifyList({ page: 1, pagesize }));
  };


  const resetFilterVerifyList = () => {
    setSearchVerifyList('');
    setVerificationInputValue('');
    setorderByverifyList
      (null);
    localStorage.removeItem('addBundleVerification');
    dispatch(fetchstockverifyList({ page: 1, pagesize }));
  };


  const onSubmit = async values => {
    try {
      const bundleNo = document.getElementById('bundle_no').value;
      const encodedBundleNumber = encodeURIComponent(bundleNo);
      await dispatch(editstockverify({
        bundle_number: encodedBundleNumber
      })).unwrap();

      message.success('Bundle Verified successfully!');

      form.resetFields(['bundle_no']);
      setPage(1);
      dispatch(
        fetchstockverifyList({
          page: pageVerification,
          pagesize: pageSizeVerification,
          ...(searchverifyList && { search: searchverifyList }),
          ...(orderByverifyList && { ordering: orderByverifyList }),
        }),
      );

      dispatch(
        fetchstockUnverifyList({
          page,
          pagesize,
          ...(search && { search: search })
        }),
      );
    } catch (error) {
      if (typeof error === 'object' && error !== null) {
        const messages = [];
        for (const key in error) {
          if (Array.isArray(error[key])) {
            messages.push(`${key}: ${error[key].join(', ')}`);
          }
        }

        if (messages.length > 0) {
          message.error(messages.join('; '));
        } else {
          message.error('Bundle verification failed');
        }
      } else if (typeof error === 'string') {
        message.error(error);
      } else {
        message.error('Bundle verification failed');
      }
    }
  };
  return (
    <div className='mainwrap'>
      <div className="sticyaction">
        <div className="sticky-header">
          <Row
            className="pagenamerow mb-0 "
            justify="space-between"
            align="middle"
          >
            <Col>
              <h2 style={{ margin: 0 }}>Bundle Verification Report</h2>
              <div className="bredcrumbwrp">
                <Link to="/stock-verification" className="back">
                  <Back /> BACK
                </Link>
                <Breadcrumb
                  items={[
                    { title: <Link to="/dashboard">Home</Link> },
                    { title: 'Bundle Verification Report' },
                  ]}
                />
              </div>
            </Col>
            <Col>
              <Space size="small">
                <Input
                  placeholder="Search"
                  className='searchbox'
                  prefix={<SearchOutlined />}
                  value={activeTab === '1' ? inputValue : inputVerificationInputValue}
                  onChange={e => {
                    if (activeTab === '1') handleSearch(e);
                    else handleSearchVerifyList(e);
                  }}
                  style={{ width: '100%' }}
                />
                <Tooltip title="Filter">
                  <Button
                    type="primary"
                    disabled={
                      activeTab === '1'
                        ? !search && !orderBy
                        : !searchverifyList && !orderByverifyList
                    }
                    className="iconlink"
                    onClick={() => {
                      if (activeTab === '1') {
                        resetFilter();
                      } else {
                        resetFilterVerifyList();
                      }
                    }}
                  >
                    <FilterIcon />
                  </Button>
                </Tooltip>
              </Space>
            </Col>
          </Row>
        </div>
        <div className="mb-3 mt-3" style={{
          backgroundColor: '#e0f2f7',
          padding: '15px', paddingBottom: "0",
          borderRadius: '5px',
          width: '100%',
        }}>
          <Form layout="vertical" form={form} onFinish={onSubmit}>
            <Row gutter={16} style={{ alignItems: 'flex-end' }}>
              <Col xs={24} md={8}>
                <Form.Item name='bundle_no'>
                  <label className='clmlbl'>Bundle No :</label>
                  <Input placeholder="Enter Bundle No." id="bundle_no" />
                </Form.Item>
              </Col>
              <Col xs={24} md={16}>
                <Form.Item>
                  <div style={{ display: 'flex', gap: '10px' }}>
                    <Button
                      type="primary"
                      className="iconlink"
                      htmlType="submit">
                      Verify Bundle
                    </Button>
                  </div>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </div>
      </div>

   
        <Tabs defaultActiveKey="1"
          className="tabletab px-4"
          onChange={handleTabChange}
        >

          <TabPane tab={`Unverified Bundles (${UnVerifydatatotalRecord})`} key="1">

            <div className='tablewrp'>
                <Table
                  rowKey="id"
                  dataSource={dataSourceTwo}
                  columns={columnsTwo}
                  pagination={false} // Disable built-in pagination
                  loading={status === 'loading'}
                  onChange={handleTableChangeUnVerifydata}
                />
              </div>
            
                <Pagination
                  current={page}
                  pageSize={pagesize}
                  total={UnVerifydatatotalRecord}
                  showSizeChanger
                  onShowSizeChange={handleUnVerifydataPageSizeChange}
                  showTotal={total => `Total ${total} items`}
                  pageSizeOptions={["20", "50", "100"]}
                  onChange={handleUnVerifydataPageChange}
                  locale={{ items_per_page: 'Items / Page' }}
                />
          
          </TabPane>


          <TabPane tab={`Verified Bundles (${totalRecord})`} key="2">
          <div className='tablewrp'>
                <Table
                  rowKey="id"
                  columns={columns}
                  dataSource={dataSource}
                  pagination={false} // Disable built-in pagination
                  loading={status === 'loading'}
                  onChange={handleTableChangeItemWiseSummary}
                  scroll={{ x: '600px' }}
                />
              </div>
           
                <Pagination
                  current={pageVerification}
                  pageSize={pageSizeVerification}
                  total={totalRecord}
                  showSizeChanger
                  onShowSizeChange={handlePageSizeChange}
                  pageSizeOptions={["20", "50", "100"]}
                  showTotal={total => `Total ${total} items`}
                  onChange={handlePageChange}
                  locale={{ items_per_page: 'Items / Page' }}
                />
        
          </TabPane>
        </Tabs>

      </div>
  );
}

export default AddNewReport;
